// SEM-67: read-only display pill for the per-grid editable lock.
// Owners flip the lock from the kebab menu on the grid header — this is
// the visual indicator only (rendered on grid headers + ProjectList rows).
export function EditablePill({ editable, fontSize = 10 }: { editable: boolean | undefined; fontSize?: number }) {
  // Backward compat: undefined = editable (legacy grids pre-SEM-67).
  const locked = editable === false
  return (
    <span
      className="chip"
      style={{ fontSize, color: locked ? 'var(--fg-3)' : undefined }}
      title={locked ? 'Locked — humans cannot edit this grid.' : 'Editable — humans can review and approve cells.'}
    >
      <span style={{ fontSize: fontSize - 1, lineHeight: 1 }}>{locked ? '🔒' : '✎'}</span>
      {locked ? 'locked' : 'editable'}
    </span>
  )
}
